import axios from 'axios'

const axiosApi = axios.create({
   baseURL: `${process.env.REACT_APP_SERVER_PROTOCOL}://${process.env.REACT_APP_SERVER_DOMAIN}${process.env.REACT_APP_SERVER_API_PATH}`
 })

export const setAuthHeader = (token, locale = 'fr') => {
 axiosApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export const setLocaleHeader = (locale) => {
  axiosApi.defaults.headers.common['Locale'] = locale
}

export default axiosApi;